export var createArray = function (size) { return new Array(size).fill(null); };
//# sourceMappingURL=array.js.map